import { StandardSpriteMaterial } from '../material/sprite_std.js';
import { BaseSprite } from './basesprite.js';
import { Vector3, Vector2, Vector4 } from '@zephyr3d/base';
import { getDevice } from '../app/api.js';

/**
 * 3D Text Sprite node
 * @public
 */ class TextSprite extends BaseSprite {
    _resolutionX;
    _resolutionY;
    _text;
    _font;
    _color;
    static _textRenderState = null;
    constructor(scene){
        super(scene);
        this.material = new StandardSpriteMaterial();
        this._resolutionX = 128;
        this._resolutionY = 128;
        this._text = '';
        this._font = '12px arial';
        this._color = new Vector3(1, 1, 1);
        this.uvTopLeft = new Vector2(0, 1);
        this.uvBottomRight = new Vector2(1, 0);
        this.material.blendMode = 'blend';
        this.scene.queueUpdateNode(this);
    }
    isSprite() {
        return true;
    }
    get resolutionX() {
        return this._resolutionX;
    }
    set resolutionX(value) {
        if (this._resolutionX !== value) {
            this._resolutionX = value;
            this.scene.queueUpdateNode(this);
        }
    }
    get resolutionY() {
        return this._resolutionY;
    }
    set resolutionY(value) {
        if (this._resolutionY !== value) {
            this._resolutionY = value;
            this.scene.queueUpdateNode(this);
        }
    }
    get text() {
        return this._text;
    }
    set text(value) {
        if (this._text !== value) {
            this._text = value;
            this.scene.queueUpdateNode(this);
        }
    }
    get textColor() {
        return this._color;
    }
    set textColor(value) {
        if (!this._color.equalsTo(value)) {
            this._color.set(value);
            this.scene.queueUpdateNode(this);
        }
    }
    get font() {
        return this._font;
    }
    set font(value) {
        if (this._font !== value) {
            this._font = value;
            this.scene.queueUpdateNode(this);
        }
    }
    update() {
        let tex = this._material.get().spriteTexture;
        if (!tex || tex.width !== this._resolutionX || tex.height !== this._resolutionY) {
            tex = getDevice().createTexture2D('rgba8unorm', this._resolutionX, this._resolutionY, {
                mipmapping: false,
                samplerOptions: {
                    minFilter: 'linear',
                    magFilter: 'linear'
                }
            });
        }
        if (!TextSprite._textRenderState) {
            TextSprite._textRenderState = getDevice().createRenderStateSet();
            TextSprite._textRenderState.useRasterizerState().setCullMode('none');
            TextSprite._textRenderState.useDepthState().enableTest(false).enableWrite(false);
        }
        const fb = getDevice().createFrameBuffer([
            tex
        ], null);
        getDevice().pushDeviceStates();
        getDevice().setFramebuffer(fb);
        getDevice().clearFrameBuffer(new Vector4(0, 0, 0, 0), null, null);
        getDevice().setFont(this._font);
        getDevice().setTextRenderStates(TextSprite._textRenderState);
        getDevice().drawText(this._text, {
            x: 0,
            y: 0,
            width: this._resolutionX,
            height: this._resolutionY
        }, this._color, {
            halign: 'left',
            valign: 'top',
            wordWrap: true
        });
        getDevice().setFont(null);
        getDevice().setTextRenderStates(null);
        getDevice().popDeviceStates();
        this._material.get().spriteTexture = tex;
        fb.dispose();
    }
}

export { TextSprite };
//# sourceMappingURL=textsprite.js.map
